import React  from 'react';
import { List, Segment, Divider, Table, Grid, Image, Header, Icon, Accordion, Button} from 'semantic-ui-react';
import { Link } from "react-router-dom";   
import InstructorCard from '../instructor/InstructorCard';
import '../../App.css';
 


const Instructores=({ strings,instructores, modalInstructor, margenes })=>{

    return (
        <Segment basic style={margenes}>
            <Header as='h2' dividing>
                {strings?strings["Instructores"]:""}
       
            </Header>
        
            <div > 
                    <InstructorCard
                        strings={strings}
                        instructores={instructores}
                        onShowModalInstructor={modalInstructor}
                        />
        
            </div>
        </Segment>
	);
};



export default Instructores;